let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dutL0")).then(() => parcelRequire('htw0K'));